'use memo';

import { useMutation } from '@tanstack/react-query';
import { toast } from '@/components/ui/use-toast';
import { appIntegrationKey } from '@/features/app-integration/query/key';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError, handleApiError } from '@/lib/api/error';
import { useTranslation } from '@/lib/i18n';
import { queryClient } from '@/lib/queryClient';
import { softwareKey } from '@/routes/_staff/software/$id/_$id/-query/key';
type Options = {
  softwareId: string;
  appUserId: string;
  appIntegrationId: string;
  onSuccess?: () => void;
};
export default function useGroupJoin({
  softwareId,
  appUserId,
  appIntegrationId,
  onSuccess
}: Options) {
  const {
    i18n
  } = useTranslation();
  return useMutation({
    mutationFn: async (groupIds: string[]) => {
      const res = await apiClient.POST('/v3/software/{softwareId}/users/{appUserId}/groups/join', {
        params: {
          path: {
            softwareId,
            appUserId
          }
        },
        body: {
          groupIds
        }
      });
      return getDataOrThrowApiError(res);
    },
    onSuccess: async () => {
      await Promise.all([queryClient.invalidateQueries({
        queryKey: appIntegrationKey.all(appIntegrationId)
      }), queryClient.invalidateQueries({
        queryKey: softwareKey.all(softwareId)
      })]);
      onSuccess?.();
    },
    onError: error => {
      const {
        message
      } = handleApiError(error, {
        language: i18n.language
      });
      toast({
        title: message
      });
    }
  });
}